import assetPath from '/app/packages/lebenslauf/articles/src/assets/bewerbungsschreiben-praktikum.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')